define("shared/components/shared/page-picker-legacy", ["exports", "@ember/component", "@ember/template-factory", "@ember/object", "@glimmer/component", "later/utils/array-methods"], function (_exports, _component, _templateFactory, _object, _component2, _arrayMethods) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;

  var _class;

  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars",0,"@ember/object",0,"@glimmer/component",0,"later/utils/array-methods"eaimeta@70e063a35619d71f

  function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }

  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    <div class="o--btnBar u--text--center">
    <span
      class="{{if this.isDecreaseDisabled 'o--btn--disabled'}} o--btn o--btn--c o--btn--mute"
      {{on "click" this.decreaseCurrentPageNumber}}
    >
      {{svg-jar "nav-left" class="o--icon"}}
    </span>
    <span class="o--btnGroup">
      {{#if @isShowRange}}
        {{#each this.clickablePages as |page|}}
          <Shared::Ui::Button
            @class={{if (eq @currentPageNumber page) "u--text--hl"}}
            @onClick={{fn @setCurrentPageNumber page}}
            @text={{page}}
            @variant="outline"
          />
        {{/each}}
      {{else}}
        {{#each this.clickablePages as |page|}}
          {{#if (eq @currentPageNumber page)}}
            <span class="u--p__sm u--text--bold">{{page}}</span>
          {{/if}}
        {{/each}}
      {{/if}}
    </span>
    <span
      class="{{if this.isIncreaseDisabled 'o--btn--disabled'}} o--btn o--btn--c o--btn--mute"
      {{on "click" this.increaseCurrentPageNumber}}
    >
      {{svg-jar "nav-right" class="o--icon"}}
    </span>
  </div>
  */
  {
    "id": "zZWBhfGb",
    "block": "[[[10,0],[14,0,\"o--btnBar u--text--center\"],[12],[1,\"\\n  \"],[11,1],[16,0,[29,[[52,[30,0,[\"isDecreaseDisabled\"]],\"o--btn--disabled\"],\" o--btn o--btn--c o--btn--mute\"]]],[4,[38,1],[\"click\",[30,0,[\"decreaseCurrentPageNumber\"]]],null],[12],[1,\"\\n    \"],[1,[28,[35,2],[\"nav-left\"],[[\"class\"],[\"o--icon\"]]]],[1,\"\\n  \"],[13],[1,\"\\n  \"],[10,1],[14,0,\"o--btnGroup\"],[12],[1,\"\\n\"],[41,[30,1],[[[42,[28,[37,4],[[28,[37,4],[[30,0,[\"clickablePages\"]]],null]],null],null,[[[1,\"        \"],[8,[39,5],null,[[\"@class\",\"@onClick\",\"@text\",\"@variant\"],[[52,[28,[37,6],[[30,3],[30,2]],null],\"u--text--hl\"],[28,[37,7],[[30,4],[30,2]],null],[30,2],\"outline\"]],null],[1,\"\\n\"]],[2]],null]],[]],[[[42,[28,[37,4],[[28,[37,4],[[30,0,[\"clickablePages\"]]],null]],null],null,[[[41,[28,[37,6],[[30,3],[30,5]],null],[[[1,\"          \"],[10,1],[14,0,\"u--p__sm u--text--bold\"],[12],[1,[30,5]],[13],[1,\"\\n\"]],[]],null]],[5]],null]],[]]],[1,\"  \"],[13],[1,\"\\n  \"],[11,1],[16,0,[29,[[52,[30,0,[\"isIncreaseDisabled\"]],\"o--btn--disabled\"],\" o--btn o--btn--c o--btn--mute\"]]],[4,[38,1],[\"click\",[30,0,[\"increaseCurrentPageNumber\"]]],null],[12],[1,\"\\n    \"],[1,[28,[35,2],[\"nav-right\"],[[\"class\"],[\"o--icon\"]]]],[1,\"\\n  \"],[13],[1,\"\\n\"],[13]],[\"@isShowRange\",\"page\",\"@currentPageNumber\",\"@setCurrentPageNumber\",\"page\"],false,[\"if\",\"on\",\"svg-jar\",\"each\",\"-track-array\",\"shared/ui/button\",\"eq\",\"fn\"]]",
    "moduleName": "shared/components/shared/page-picker-legacy.hbs",
    "isStrictMode": false
  });

  let PagePickerLegacyComponent = (_class = class PagePickerLegacyComponent extends _component2.default {
    get clickablePages() {
      return (0, _arrayMethods.generateRangedArray)(this.args.maxPageNumber, 1);
    }

    get isDecreaseDisabled() {
      return this.args.currentPageNumber <= this.args.minPageNumber;
    }

    get isIncreaseDisabled() {
      return this.args.currentPageNumber >= this.args.maxPageNumber;
    }

    decreaseCurrentPageNumber() {
      if (!this.isDecreaseDisabled) {
        this.args.setCurrentPageNumber(this.args.currentPageNumber - 1);
      }
    }

    increaseCurrentPageNumber() {
      if (!this.isIncreaseDisabled) {
        this.args.setCurrentPageNumber(this.args.currentPageNumber + 1);
      }
    }

  }, (_applyDecoratedDescriptor(_class.prototype, "decreaseCurrentPageNumber", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "decreaseCurrentPageNumber"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "increaseCurrentPageNumber", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "increaseCurrentPageNumber"), _class.prototype)), _class);
  _exports.default = PagePickerLegacyComponent;
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, PagePickerLegacyComponent);
});